/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AiAcceptOutcome = {
    Actioned: 'actioned',
    ManualActionRequired: 'manual_action_required',
} as const;
export type AiAcceptOutcome = typeof AiAcceptOutcome[keyof typeof AiAcceptOutcome];


export function instanceOfAiAcceptOutcome(value: any): boolean {
    for (const key in AiAcceptOutcome) {
        if (Object.prototype.hasOwnProperty.call(AiAcceptOutcome, key)) {
            if (AiAcceptOutcome[key as keyof typeof AiAcceptOutcome] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AiAcceptOutcomeFromJSON(json: any): AiAcceptOutcome {
    return AiAcceptOutcomeFromJSONTyped(json, false);
}

export function AiAcceptOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiAcceptOutcome {
    return json as AiAcceptOutcome;
}

export function AiAcceptOutcomeToJSON(value?: AiAcceptOutcome | null): any {
    return value as any;
}

export function AiAcceptOutcomeToJSONTyped(value: any, ignoreDiscriminator: boolean): AiAcceptOutcome {
    return value as AiAcceptOutcome;
}

